import React, { useEffect, useState } from 'react';
import {
  Dialog, DialogTitle, DialogContent, DialogActions, Button, Tabs, Tab, TextField, Typography,
  List, ListItemButton, ListItemText, FormControlLabel, Switch,
} from '@mui/material';
import { SOURCE_GROUPS } from './dispatchConstants';

const groupIndexForValue = (value) => {
  const prefix = String(value || '').split('.')[0];
  const i = SOURCE_GROUPS.findIndex(g => g.prefix === prefix);
  return i === -1 ? 0 : i;
};

const SourcePickerDialog = ({
  open, onClose, value, dynamicItems, onSelect,
}) => {
  const [tab, setTab] = useState(0);
  const [query, setQuery] = useState('');
  const [showAll, setShowAll] = useState(false);

  useEffect(() => {
    if (open) {
      setTab(groupIndexForValue(value));
      setQuery('');
      setShowAll(false);
    }
  }, [open, value]);

  const group = SOURCE_GROUPS[tab] || SOURCE_GROUPS[0];
  const dyn = dynamicItems && dynamicItems[group.prefix];
  const isDynamic = !!dyn;
  const items = isDynamic
    ? dyn
    : group.items.map(field => ({
      value: `${group.prefix}.${field}`, primary: field, secondary: `${group.prefix}.${field}`,
    }));

  const hasRelevance = items.some(it => it.relevant === false);
  const q = query.trim().toLowerCase();
  let base = items;
  if (hasRelevance && !showAll && !q) base = items.filter(it => it.relevant !== false);
  const filtered = q
    ? items.filter(it => it.primary.toLowerCase().includes(q) || String(it.secondary).toLowerCase().includes(q))
    : base;

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle>Choose source</DialogTitle>
      <Tabs
        value={tab}
        onChange={(e, v) => { setTab(v); setQuery(''); setShowAll(false); }}
        variant="scrollable"
        scrollButtons="auto"
        sx={{ px: 2, borderBottom: 1, borderColor: 'divider' }}
      >
        {SOURCE_GROUPS.map(g => <Tab key={g.group} label={g.label} />)}
      </Tabs>
      <DialogContent dividers>
        <Typography variant="body2" color="textSecondary" sx={{ mb: 1 }}>{group.description}</Typography>
        {isDynamic && (
          <TextField size="small" fullWidth placeholder="Search fields…" value={query} onChange={e => setQuery(e.target.value)} sx={{ mb: 1 }} />
        )}
        {hasRelevance && (
          <FormControlLabel
            control={<Switch size="small" checked={showAll} onChange={e => setShowAll(e.target.checked)} />}
            label="Show all fields"
          />
        )}
        <List dense sx={{ maxHeight: 360, overflow: 'auto' }}>
          {filtered.length === 0 && (
            <Typography variant="body2" color="textSecondary" sx={{ p: 1 }}>No matching sources.</Typography>
          )}
          {filtered.map(it => (
            <ListItemButton key={it.value} selected={value === it.value} onClick={() => onSelect(it.value)}>
              <ListItemText primary={it.primary} secondary={it.secondary} />
            </ListItemButton>
          ))}
        </List>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Cancel</Button>
      </DialogActions>
    </Dialog>
  );
};

export default SourcePickerDialog;
